import React from 'react'

import { Chart as Component } from './Chart'

const Chart = props => {
  return <Component {...props} />
}
export default Chart
